(function (window, $j) {
	//Language selector on Utility Nav
    $j("input:radio[name='language-switcher']").change(function () {
		$j.ajax({
			url: "/LanguageSwitcher",
			type: "GET",
			data: { language: $j(this).val(), id: $j(this).closest("[data-name='language']").attr("rel") },
			context: this,
			success: function (data) {
				location.href = data;
			},
			error: function (data) {
				alert("Error" + data);
			}
		});
	});

})(window, $j);


